import { jsx as _jsx } from "react/jsx-runtime";
import configment from '@adc/configment';
import { Button } from '../elementals';
export const DownloadLink = ({ resource, children, embeddedContext = 'browser', variant = 'anchor', buttonProps = {}, }) => {
    const downloadUrl = `${configment.get('RESI_GRAPH_API_URL_EXTERNAL')}/download/${resource.urn}`;
    if (variant === 'button') {
        return (_jsx(Button, { ...buttonProps, link: downloadUrl, children: children ?? 'Download' }));
    }
    return (_jsx("a", { href: downloadUrl, rel: 'noopener noreferrer', target: embeddedContext === 'webview' ? '_self' : '_blank', "data-elm-id": `download_link_${resource.urn}`, children: children ?? 'Download' }));
};
export default DownloadLink;
//# sourceMappingURL=index.js.map